/**
 * Create an identifier for one frontend network transaction.
 *
 * @returns {string}
 */
export const createTransactionId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return `tx_${crypto.randomUUID()}`;
    }

    return `tx_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
};
